{
  "entity": {
    "announcement": "お知らせ",
    "api_key": "他のアプリ用キー",
    "attribute_definition": "商品の追加項目",
    "audit_log": "変更履歴",
    "background_job": "バックグラウンド作業",
    "bank_import_batch": "銀行ファイル",
    "bank_import_line": "銀行ファイルの行",
    "brand": "ブランド",
    "bulk_job": "一括変更",
    "buylist_intake": "買取",
    "card": "カード",
    "card_set": "カードセット",
    "carrier": "配送業者",
    "cash_movement": "入出金",
    "category": "カテゴリ",
    "collection": "コレクション",
    "condition_export_map": "マーケット用の状態表",
    "consignment_intake": "委託受付",
    "consignment_item": "委託品",
    "consignment_report": "委託レポート",
    "consignment_return": "委託者への返却",
    "consignment_sale": "委託品の販売",
    "consignor": "委託者",
    "customer": "お客様",
    "dead_letter": "届かなかった更新",
    "discount": "割引コード",
    "document": "書類",
    "document_export_job": "書類のダウンロード",
    "dsar": "個人情報の請求",
    "dsar_request": "個人情報の請求",
    "edc_settlement_batch": "カード端末の明細",
    "edc_statement_line": "カード端末明細の行",
    "event": "システムの更新",
    "export_evidence": "輸出の証拠",
    "export_job": "ダウンロード",
    "facet_config": "検索の絞り込み",
    "fx_rate": "為替レート",
    "game": "カードゲーム",
    "identity_check": "本人確認",
    "import_job": "ファイル取り込み",
    "inbox_item": "やること",
    "inventory_item": "在庫",
    "kobutsu_export": "古物台帳のダウンロード",
    "kobutsu_ledger": "古物台帳",
    "label_job": "ラベル印刷",
    "legal_calendar": "法令カレンダー",
    "localization": "サイトの言語",
    "mail_settings": "メール送信",
    "market": "国グループ",
    "media_asset": "画像",
    "media_folder": "画像フォルダ",
    "media_item": "画像",
    "media_tag": "画像タグ",
    "menu": "サイトのメニュー",
    "not_found_hit": "見つからないアドレス",
    "notification": "メール",
    "notification_preference": "メールの受信設定",
    "notification_setting": "通知の設定",
    "notification_template": "メールの文面",
    "offline_batch": "オフライン中のレジ販売",
    "offline_op": "オフライン中のレジ操作",
    "order": "注文",
    "order_export": "注文のダウンロード",
    "order_line": "注文の行",
    "order_setting": "注文の設定",
    "oversell_conflict": "二重販売",
    "page": "サイトのページ",
    "payment": "支払い",
    "payment_export": "支払いのダウンロード",
    "payment_method_config": "決済方法",
    "payments_ledger": "支払いの台帳",
    "payout": "委託者への支払い",
    "payout_batch": "委託者への一括支払い",
    "policy": "規約ページ",
    "pos_cart": "レジのかご",
    "pos_device": "レジ",
    "pos_hold": "保留中の会計",
    "pos_sale": "レジの販売",
    "pos_setting": "レジの設定",
    "product": "商品",
    "receipt": "領収書",
    "redirect": "古いアドレスの転送",
    "redirect_import": "ファイルからの転送",
    "refund": "返金",
    "register": "レジ",
    "reservation": "取り置き",
    "revalidation": "サイトの更新",
    "role": "役割",
    "saved_view": "保存した表示",
    "search_index": "サイト検索",
    "search_settings": "検索の設定",
    "section_group": "サイトデザインの部分",
    "section_manifest": "サイトデザインの部品",
    "security_incident": "セキュリティ事故",
    "service": "システムの部分",
    "shift": "レジのシフト",
    "shipping_rate": "配送方法",
    "shipping_zone": "配送エリア",
    "signing_key": "セキュリティキー",
    "staff": "スタッフ",
    "staff_user": "スタッフ",
    "stock_discrepancy": "在庫の差異",
    "store_credit_ledger": "ストアクレジット",
    "store_credit_lot": "ストアクレジット",
    "store_credit_snapshot": "ストアクレジット",
    "synonym_set": "検索の言い換え",
    "tax": "税",
    "tax_calculation": "税の計算",
    "tax_free_customs_import": "税関ファイル（免税）",
    "tax_free_export_batch": "税務署向け免税ファイル",
    "tax_free_passport": "旅券（免税）",
    "tax_free_record": "免税販売",
    "tax_free_verification": "免税の確認",
    "tax_setting": "税の設定",
    "taxfree_record": "免税販売",
    "template": "ページのレイアウト",
    "theme": "サイトデザイン",
    "translation": "翻訳",
    "translations": "翻訳",
    "ui_strings": "サイトの文言",
    "variant": "販売商品",
    "webhook_endpoint": "他のアプリへの接続",
    "retention_job": "保存期間による自動整理"
  },
  "entity_other": "記録",
  "audit": {
    "title": "変更履歴",
    "intro": "誰が、いつ、何をしたか。行を開くと何が変わったかが分かります。",
    "default_range": "日付を選ばないときは直近{{days}}日分を表示します。",
    "time": "日時",
    "who": "誰が",
    "what": "内容",
    "record": "対象",
    "ip": "接続元",
    "filter_record": "対象の種類",
    "filter_who": "スタッフ",
    "filter_kind_of_who": "操作した人",
    "filter_area": "店の部分",
    "filter_dates": "日付",
    "filter_id": "対象の番号",
    "actor": {
      "staff": "スタッフ",
      "customer": "お客様",
      "system": "システム",
      "service": "システム",
      "api_key": "他のアプリ",
      "pos": "レジ"
    },
    "area": {
      "catalog": "商品",
      "inventory": "在庫",
      "orders": "注文",
      "payments": "支払い",
      "pos": "レジ",
      "consignment": "委託",
      "tax": "税",
      "cms": "サイト",
      "identity": "スタッフ・サインイン",
      "notification": "通知",
      "media": "画像・書類",
      "search": "サイト検索"
    },
    "verb": {
      "created": "{{what}}を作成",
      "updated": "{{what}}を変更",
      "deleted": "{{what}}を削除",
      "status": "{{what}}の状態を変更",
      "viewed": "{{what}}を閲覧・ダウンロード",
      "signin": "サインイン・セキュリティ: {{what}}",
      "price": "{{what}}の価格を変更",
      "price_from_to": "{{what}}の価格を変更 {{from}} → {{to}}"
    },
    "open_record": "対象を開く",
    "no_fields": "この変更の項目の詳細は保存されていません。",
    "technical_hidden": "システム用の項目も {{count}} 件変わりました（表示しません）。",
    "field": "項目",
    "before": "変更前",
    "after": "変更後",
    "hidden": "非表示",
    "export_failed": "ファイルを作れませんでした。期間を短くしてください。",
    "fields": {
      "price": "価格",
      "compareAtPrice": "割引前の価格",
      "status": "状態",
      "title": "タイトル",
      "name": "名前",
      "email": "メール",
      "phone": "電話",
      "address": "住所",
      "note": "メモ",
      "quantity": "数量",
      "rawRank": "ランク",
      "permissions": "できること",
      "roleId": "役割",
      "active": "有効",
      "tags": "タグ",
      "fee": "手数料",
      "feePercent": "手数料率",
      "amount": "金額"
    }
  },
  "jobs": {
    "title": "バックグラウンド処理・バックアップ",
    "intro": "システムが自動で行う作業: 動いているか、失敗していないか、最後のバックアップはいつか。",
    "problems_title": "バックグラウンド処理の問題",
    "problems_count_other": "未対応 {{count}}件",
    "problems_none": "なし",
    "to_inbox": "やること一覧で問題を開く",
    "scheduled_title": "定期処理",
    "never": "未実行",
    "took": "{{seconds}}秒",
    "run_now": "今すぐ実行",
    "started": "「{{name}}」を開始しました。",
    "run_failed": "処理を開始できませんでした。",
    "confirm_title": "「{{name}}」を今すぐ実行しますか？",
    "confirm_body": "いつもの時刻とは別に、今1回実行します。",
    "status": {
      "ok": "完了",
      "failed": "失敗",
      "running": "実行中",
      "never": "未実行",
      "queued": "実行待ち",
      "stuck": "止まっています"
    },
    "names": {
      "all": {
        "purge_expired_plumbing": "古いシステム記録の整理"
      },
      "catalog": {
        "publish_scheduled": "予約した商品の販売開始",
        "purge_deleted_products": "削除済み商品の完全削除",
        "purge_expired_exports": "古いダウンロードファイルの削除",
        "recheck_compare_at": "比較価格の再確認（景品表示法）",
        "refresh_smart_collections_all": "自動コレクションの更新",
        "retry_stalled_jobs": "止まった取込・書出しの再実行"
      },
      "cms": {
        "announcement_schedule": "お知らせの表示・非表示（予約）",
        "backup_content": "サイト内容のバックアップ",
        "cms_housekeeping": "古い下書きの整理",
        "media_usage_refresh": "画像の使用箇所の数え直し",
        "publish_scheduled_pages": "予約したページの公開",
        "scheduled_publish": "予約したサイト変更の公開"
      },
      "consignment": {
        "consignment_expiry": "委託期間の終了",
        "consignment_items_closer": "終わった委託品の締め",
        "consignment_stage_gauge": "委託品の段階ごとの件数",
        "identity_retention_purge": "保存期間を過ぎた本人確認書類の削除",
        "intake_documents_sweeper": "受付書類の仕上げ",
        "items_catalog_sweeper": "委託品と商品のひも付け",
        "kobutsu_completeness_check": "古物台帳の記入もれ確認",
        "kobutsu_retention_report": "古物台帳の保存レポート（月次）",
        "payout_schedule": "委託者への支払い準備",
        "payout_statement_sweeper": "支払明細の作成",
        "price_proposals_sweeper": "返事のない価格提案の締め",
        "returns_sweeper": "委託者への返品のフォロー",
        "settlements_sweeper": "売れた委託品の精算"
      },
      "identity": {
        "audit_maintenance": "変更履歴の封印と保管",
        "dsar_follow_up": "個人データ請求のフォロー",
        "purge_expired_identity": "期限切れのログインリンク・コードの削除"
      },
      "inventory": {
        "reconcile_ledger": "在庫数の照合"
      },
      "media": {
        "document_integrity": "保存書類の破損確認",
        "document_retention": "保存期間を過ぎた書類の削除",
        "expire_document_exports": "古い書類ダウンロードの削除",
        "gc_orphans": "使われていないアップロードの削除",
        "refresh_storage_bytes": "使用容量の数え直し",
        "requeue_stuck_assets": "止まった画像処理の再実行",
        "restricted_retention": "保存期間を過ぎた本人確認画像の削除",
        "retry_stuck_documents": "止まった領収書・PDFの再作成"
      },
      "notification": {
        "notification_tick": "リマインダー・まとめ・待ちメールの送信"
      },
      "orders": {
        "expire_carts": "古いカートを空にする",
        "expire_checkouts": "未完了のご注文手続きの解放",
        "expire_order_tokens": "古い注文追跡リンクの終了",
        "import_jp_postal": "郵便番号データの更新",
        "remind_uncollected_pickups": "未受取の店頭受取のお知らせ",
        "saga_compensate": "支払い失敗のご注文手続きの取り消し"
      },
      "payments": {
        "expire_bank_transfers": "期限内に入金のない銀行振込の取消",
        "expire_store_credit": "期限切れストアクレジットの終了",
        "payments_ledger_check": "入金と台帳の照合",
        "store_credit_kijunbi_snapshot": "基準日のストアクレジット残高（資金決済法）"
      },
      "search": {
        "purge_search_query_log": "古い検索語の削除",
        "search_consistency_check": "サイト内検索のもれ確認",
        "search_recover_stalled": "止まった検索更新の再実行",
        "sync_collection_members": "検索のコレクション更新"
      },
      "tax": {
        "calendar_alerts": "税・法律の期日のお知らせ",
        "evidence_reminder": "輸出証明の不足のお知らせ",
        "purge_pii": "保存期間を過ぎた個人データの削除",
        "refresh_fx": "為替レートの更新",
        "tax_reconcile": "税の記録とご注文の照合",
        "taxfree_expire": "90日を過ぎた免税記録の締め",
        "taxfree_transmit": "購入記録情報の送信（免税）"
      },
      "realtime": {
        "purge_connection_audit": "古いライブ更新接続記録の削除"
      }
    },
    "next": "次回:",
    "already_waiting": "「{{name}}」はすでに実行待ちです。",
    "already_running": "「{{name}}」はいま実行中です。終わってからもう一度お試しください。",
    "not_allowed": "この作業は手動では実行できません。",
    "stuck_stopped": "途中で止まりました（動かしている部分が再起動しました）。「今すぐ実行」でもう一度始められます。",
    "stuck_not_picked_up": "長い時間待ったままです。動かしている部分が止まっている可能性があります。IT担当に確認を頼んでください。",
    "could_not_read": "作業の一覧をいま読み込めませんでした。自動でもう一度試します。",
    "unreachable": "応答がありません: {{parts}} — その作業は下に表示されていません。",
    "not_connected_parts": "まだ接続されていません: {{parts}}",
    "small_title_one": "1時間ごと以上に動く小さな作業 {{count}}件",
    "small_title_other": "1時間ごと以上に動く小さな作業 {{count}}件"
  },
  "backups": {
    "title": "バックアップ",
    "last": "最後のバックアップ",
    "size": "サイズ",
    "where": "保存先",
    "next": "次のバックアップ",
    "kept": "保存期間",
    "days_other": "{{count}}日",
    "drill": "最後の復元テスト",
    "drill_ok": "成功",
    "drill_failed": "失敗",
    "never": "なし",
    "plan": "復元はIT担当が手順書（{{path}}）で行います — ここには意図的に復元ボタンがありません。",
    "state": {
      "ok": "最新です",
      "too_old": "{{hours}}時間より古い",
      "never": "バックアップがありません",
      "unreadable": "状態を読み込めません"
    },
    "could_not_read": "バックアップの状態をいま読み込めませんでした。自動でもう一度試します。",
    "not_configured": "このサーバーではバックアップ状態の表示がまだ設定されていません。バックアップは毎晩{{time}}（日本時間）に行われ、{{days}}日間保存されます。",
    "unreadable": "バックアップの状態ファイルを読み込めません — IT担当に保存先の確認を依頼してください。",
    "last_try_failed": "前回のバックアップは失敗しました:",
    "encrypted": "暗号化済み",
    "storage": {
      "online": "オンラインストレージ（{{name}}）",
      "online_unnamed": "オンラインストレージ",
      "this_server": "このサーバー内のみ"
    }
  },
  "health": {
    "title": "すべて動いていますか？",
    "all_ok": "すべて動いています",
    "some_down_other": "{{count}}か所に問題があります",
    "ok": "稼働中",
    "no_answer": "応答なし",
    "problem_with": "問題: {{what}}",
    "build": "管理画面のバージョン: {{release}}",
    "uptime": "監視画面",
    "errors": "エラー報告",
    "check": {
      "database": "データベース",
      "nats": "メッセージ"
    },
    "service": {
      "identity": "スタッフ・サインイン",
      "catalog": "商品",
      "inventory": "在庫",
      "tax": "税",
      "orders": "注文・配送",
      "payments": "支払い",
      "pos": "レジ",
      "consignment": "委託",
      "cms": "サイトの内容",
      "media": "画像・書類",
      "search": "サイト検索",
      "notification": "メール・やること",
      "realtime": "自動更新"
    }
  },
  "features": {
    "title": "今後の機能",
    "intro": "他のプラットフォームとの連携は今後のフェーズで作ります。それまではオフのままです。",
    "when": "オーナーが依頼し、そのフェーズが完成したときにオンになります — ここにスイッチはありません。",
    "error": "現在の設定を読み込めませんでした — すべて「オフ」として表示しています。",
    "on": "オン",
    "off": "オフ",
    "where": "表示される場所",
    "names": {
      "payments__stripe": "サイトでのカード決済（Stripe）",
      "payments__stripe_connect": "委託者への支払い（Stripe）",
      "channels__ebay": "eBay",
      "channels__whatnot": "Whatnot",
      "channels__mercari": "メルカリ",
      "channels__tiktok_shop": "TikTok Shop",
      "tax__nta_api": "免税記録の国税庁へのオンライン送信",
      "shipping__shipandco": "送り状の発行（Ship&co）",
      "shipping__zonos": "注文時の関税（Zonos）"
    }
  },
  "refresh": {
    "title": "サイトの更新",
    "intro": "変更のあと、店はサイトに新しく表示する部分を知らせます。届いたかどうかを確認し、もう一度送信できます。",
    "todo": "ウェブサイトがまだ更新されていない可能性があります",
    "todo_close": "完了",
    "todo_done": "やることを閉じました。",
    "manual_title": "サイトの一部を今すぐ更新",
    "manual_intro": "サイトに古い内容が表示されるときに使います。",
    "refresh_part": "更新: {{part}}",
    "part_sent": "{{part}}の更新を送信しました。",
    "error": "更新の履歴を読み込めませんでした。",
    "empty": "更新はまだありません。",
    "not_configured": "サイトとの接続が設定されていないため、更新は送られません（IT担当）。",
    "send_again": "もう一度送信",
    "sent_again": "もう一度送信しました — 通常は数秒で届きます。",
    "status": {
      "done": "完了",
      "retrying": "再試行中",
      "failed": "未反映 — 自動で再試行中",
      "stopped": "再試行を終了",
      "joined": "後の更新と一緒に送信",
      "waiting": "送信中",
      "off": "オフ"
    },
    "parts": {
      "design": "サイトデザイン",
      "page": "ページ",
      "rules": "規約ページ",
      "menu": "メニュー",
      "redirects": "古いアドレス",
      "announcements": "お知らせ",
      "texts": "サイトの文言",
      "languages": "サイトの言語",
      "products": "商品",
      "collections": "コレクション",
      "other": "その他"
    },
    "for_it": "IT向けの詳細",
    "it_tags": "タグ",
    "it_attempts": "試行回数",
    "it_answer": "応答コード",
    "it_error": "エラー"
  }
}
